import { render, staticRenderFns } from "./ConversionsList.vue?vue&type=template&id=55f70fc2&scoped=true&"
import script from "./ConversionsList.vue?vue&type=script&lang=ts&"
export * from "./ConversionsList.vue?vue&type=script&lang=ts&"
import style0 from "./ConversionsList.vue?vue&type=style&index=0&id=55f70fc2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f70fc2",
  null
  
)

export default component.exports